
import {Component, Vue} from "vue-property-decorator";
import {httpResource} from "@/resources/http.resource";
import {IBook} from "@/interfaces/book.interface";
import {IParkChoice} from '@/interfaces/park-choice.interface';
import AppPageHeader from "@/components/AppPageHeader.vue";
import {IAppState} from "@/interfaces/app-state.interface";
import AppCorpsFilter from "@/components/FormControls/AppCorpsFilter.vue";

@Component({
  components: {
    AppCorpsFilter,
    AppPageHeader,
  },
})
export default class PageParkingAccess extends Vue {
  isLoading: boolean = true;
  publicPath = process.env.VUE_APP_PUBLIC_URL;
  corpsSelected = null;
  parksSelected= [];
  parks = [];
  ListCorps = {};

  async created() {
    try {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('initialized');
      const { data: {result: {parksMyPrivat: responseParksMyPrivat }}} = await httpResource.httpAction({ action: IParkChoice.ACTION, params: {command: IParkChoice.Commands.PARKS_MY_PRIVAT} });
      this.parks = responseParksMyPrivat;
      await this.updateFilter();
      this.isLoading = false;
    }
    catch (error) { await this.$store.dispatch('handleError', error) }
  }

  async updateFilter () {
    let asyncAction = async () => {
      const parksIdString = this.parksSelected.join();
      const params = {
        command: IParkChoice.Commands.LIST_CORPS,
        parks: parksIdString,
        corpId: this.corpsSelected ? this.corpsSelected : null
      };
      const {data: { result: { ListCorps: responseListCorps } }} = await httpResource.httpAction({ action: IParkChoice.ACTION, params });
      this.ListCorps = null;

      if (responseListCorps && responseListCorps.length) {
        this.ListCorps = {};

        responseListCorps.forEach((item) => {
          if (!this.ListCorps[item.corpId]) {
            let corpItem = {
              corpName: item.corpName,
              corpId: item.corpId,
              parks: {
                ['park-' + item.parkId]: {
                  cb: item.cb,
                  parkName: item.parkName,
                  parkId: item.parkId,
                },
              },
            };

            Vue.set(this.ListCorps, item.corpId, corpItem);
          }
          else { Vue.set(this.ListCorps[item.corpId].parks, 'park-' + item.parkId, { cb: item.cb, parkName: item.parkName, parkId: item.parkId, }); }
        });
      }
    };
    await this.$store.dispatch('defaultResourceAction', { asyncAction });
  }

  async parkUpdate (flag, parkKey, corpId) {
    let asyncAction = async () => {
      const params = {
        command: flag ? IParkChoice.Commands.CORP_ADD : IParkChoice.Commands.CORP_DEL,
        parks: this.ListCorps[corpId].parks[parkKey].parkId, corpId: corpId
      };
      await httpResource.httpAction({ action: IParkChoice.ACTION, params });
    };
    let success = await this.$store.dispatch('defaultResourceAction', { asyncAction });
    if (success) this.ListCorps[corpId].parks[parkKey].cb = flag;
  }

  async parkUpdateMult (flag) {
    await Promise.all(Object.keys(this.ListCorps).map(async (corpId) => {
      const params = {
        command: flag ? IParkChoice.Commands.CORP_ADD : IParkChoice.Commands.CORP_DEL,
        parks: Object.keys(this.ListCorps[corpId].parks).map((item) => this.ListCorps[corpId].parks[item].parkId).join(),
        corpId: corpId,
      };
      await httpResource.httpAction({ action: IParkChoice.ACTION, params });
      Object.keys(this.ListCorps[corpId].parks).forEach(parkId => this.ListCorps[corpId].parks[parkId].cb = flag);
    }));
  }
}
